import React from 'react'
import { Box } from '@mui/material'
import IngredientsToolbar from '../IngredientsToolbar'
import RecipeStatus from '../RecipeStatus'
import IngredientDemo from '../IngredientDemo'

import './RecipeBuilder.scss'

const RecipeBuilder = () => {
    return (
        <Box className="recipe-builder">
            <IngredientsToolbar />
            <IngredientDemo />
            <Box id="builder-status-section">
                {/* <Button variant="contained">Preview</Button> */}
                <RecipeStatus />
            </Box>
        </Box>
    )
}

export default RecipeBuilder